module.exports = __webpack_public_path__ + "img/blueCoin.925c6c48.png";